import { LocaleContext } from 'components/MainComponent/MainComponent'
import { useContext } from 'react'
import styled from 'styled-components'

export const AbbauChart_DESK = ({
  hlColor,
  curveColor,
}: {
  hlColor: string
  curveColor: string
}) => {
  const TEXT = useContext(LocaleContext).abbauchart
  return (
    <StyledAbbauChart
      width='665.6401'
      height='214.7944'
      viewBox='0 0 665.6401 214.7944'
    >
      <path
        d='M256.1773,191.0645v4.8974m66.4754-4.9106v5.1078m204.7233-5.0968v4.8974m-68.4877-4.8974v4.8974m-69.4649-4.9215v5.1209m-201.9408-5.1122v5.1122m-67.3034-5.1122v5.1122'
        fill='none'
        stroke={hlColor}
        strokeWidth='.75'
      />
      <path
        d='M45.7119,98.3003l373.6958,.0087'
        fill='none'
        stroke={hlColor}
        strokeDasharray='0 0 0 6'
        strokeLinecap='round'
        strokeWidth='1.5'
      />
      <line
        x1='45.7119'
        y1='4.9565'
        x2='165.5052'
        y2='4.9565'
        fill='none'
        stroke={hlColor}
        strokeDasharray='0 0 0 6'
        strokeLinecap='round'
        strokeWidth='1.5'
      />
      <g>
        <path
          d='M57.1293,190.2749S146.2756,6.2395,187.4802,6.2395c62.4965,0,451.4793,184.7349,451.4793,184.7349'
          fill='none'
          stroke={curveColor}
          strokeLinecap='round'
          strokeWidth='4'
        />
        <line
          x1='0'
          y1='190.4691'
          x2='663.7769'
          y2='190.4691'
          fill='none'
          stroke={hlColor}
          strokeWidth='.75'
        />
        <path
          d='M594.5576,191.0702v5.0881m-.621-5.0881v5.0881'
          fill='none'
          stroke={hlColor}
          strokeWidth='.75'
        />
        <line
          x1='663.7769'
          y1='190.9506'
          x2='663.7769'
          y2='196.1589'
          fill='none'
          stroke={hlColor}
          strokeWidth='.75'
        />
      </g>
      <text transform='translate(0 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          {TEXT[2]}
        </tspan>
      </text>
      <text transform='translate(115.6793 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          1
        </tspan>
      </text>
      <text transform='translate(182.9826 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          2
        </tspan>
      </text>
      <text transform='translate(251.6773 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          3
        </tspan>
      </text>
      <text transform='translate(318.9807 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          4
        </tspan>
      </text>
      <text transform='translate(384.9235 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          5
        </tspan>
      </text>
      <text transform='translate(452.2268 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          6
        </tspan>
      </text>
      <text transform='translate(522.8761 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          7
        </tspan>
      </text>
      <text transform='translate(590.1794 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          8
        </tspan>
      </text>
      <text transform='translate(656.6402 211.1198)' fill={hlColor}>
        <tspan x='0' y='0'>
          9
        </tspan>
      </text>
      <text transform='translate(0 12)' fill={hlColor}>
        <tspan x='0' y='0'>
          1,0‰
        </tspan>
      </text>
      <text transform='translate(0 106)' fill={hlColor}>
        <tspan x='0' y='0'>
          0,5‰
        </tspan>
      </text>
      {/* <text transform='translate(0 196)' fill={hlColor}>
        <tspan x='0' y='0'>
          0
        </tspan>
      </text> */}
    </StyledAbbauChart>
  )
}

const StyledAbbauChart = styled.svg`
  font-family: var(--font-sans-serif);
  font-size: 15px;
  max-width: 100%;
  padding: 0;
`
